import { Link, Outlet } from "react-router-dom"
import styled from "styled-components"
import { ReactComponent as LogoJP } from "../assets/logo_jp.svg"
import { devices } from "../themes/theme"

const Page = styled.div`
  background-color: ${(props) => props.theme.colors.bodyBackground};
  min-height: 100vh;
  margin-inline: 1rem;

  @media ${devices.tablet} {
    margin-inline: 12.5%;
  }
`

const Main = styled.main`
  display: flex;
  align-items: center;
  flex-direction: column;
`

const Header = styled.header`
  padding-block: clamp(0.5rem, -0.1rem + 3vw, 3.5rem)
    clamp(2rem, 1.7rem + 1.5vw, 3.5rem);
  width: 100%;
`

const Footer = styled.footer`
  width: 100%;
  text-align: center;
  padding-top: 6rem;
  padding-bottom: 7.5rem;
  font-family: "${(props) => props.theme.fontFamilyEN}", sans-serif;
  font-size: 12px;
  line-height: 140%;
`
const StyledLogo = styled(LogoJP)`
  width: clamp(10rem, 8.9rem + 5.5vw, 15.5rem);
`

const Root = () => {
  return (
    <Page>
      <Main>
        <Header>
          <Link to="https://jp.josys.com/">
            <StyledLogo title="josys-logo" />
          </Link>
        </Header>
        <Outlet />
      </Main>
      <Footer>
        Copyright © {new Date().getFullYear()} JOSYS INC. All Rights Reserved.
      </Footer>
    </Page>
  )
}

export { Root }
